import type { FunctionComponent } from 'react';
import { ButtonLink } from '@fff-web/fff-ui-shared';
import { CUSTOM_CARE_URL } from '../../../utils/redirectLinks';
import * as styles from './Legal.module.css';

const Legal: FunctionComponent = () => {
  const handleClickSeeDetails = () => {
    window.location.href = CUSTOM_CARE_URL;
  };

  return (
    <div className={styles.legalContainer} data-testid="legal-container">
      <p className={styles.supContainer}>
        <sup>1</sup>
        Box values vary each season and depend on customization choices.
      </p>
      <p className={styles.buttonLinkContainer}>
        Have questions about cancel?{' '}
        <ButtonLink label="See Details" type="gray" onClick={handleClickSeeDetails} bold />
      </p>
    </div>
  );
};

export default Legal;
